<template>
	<!-- 菜单的最后一级 -->
  <el-menu-item v-if="!data.children || data.children.length === 0" :index="data.id">{{ data.name }}</el-menu-item>
	<!-- 菜单目录 -->
  <el-submenu v-else :index="data.id">
    <template slot="title">
        <span>{{data.name}}</span>
    </template>
    <template v-for="item in data.children">
    <SubMenu :data="item" :key="item.id"></SubMenu>
    </template>

    <!-- <el-submenu :index="data.id">
      <template slot="title"><span>慢病</span></template>
      <el-menu-item  :index="data.id">糖尿病糖尿病糖尿病糖尿病糖尿病糖尿病</el-menu-item>
    </el-submenu> -->

  </el-submenu>

</template>

<script>
export default {
  name: 'SubMenu',
  props: {
    data: Object,
  },
}
</script>